<template>
  <v-container class="mx-2" fluid>
    <h1 class="mb-8">{{ textTitle }}</h1>
    <v-row>
      <v-col cols="5" class="pr-10">
        <div class="type-barrier-select">
          <v-text-field
            label="Тип"
            v-model="typeController"
            item-text="name"
            prepend-inner-icon="mdi-format-list-bulleted-type"
            item-value="value"
            outlined
            dense
            hide-details
            flat
            readonly
          />
        </div>
      </v-col>
    </v-row>
    <NewController />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import NewController from './components/NewController';

export default {
  name: 'BaseFormNewController',
  components: { NewController },
  data () {
    return {
      valid: true,
      value: '',
      typeController: 'Контроллер',
    };
  },
  computed: {
    textTitle () {
      return 'new Controller';
    },
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      loadManagementCompanies: 'ManagementCompany/getManagementCompanies',
    }),
  },
  created () {
    this.loadManagementCompanies();
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 600px) {
  .type-barrier-select {
    width: 200px;
  }
}
</style>
